"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOrganizationsRequest = void 0;
const api_1 = require("./api");
Object.defineProperty(exports, "fetchOrganizationsRequest", { enumerable: true, get: function () { return api_1.fetchOrganizationsRequest; } });
